import Text from '@components/Text';
import colors from '@constants/colors';

import styles from './styles.module.scss';

function CartNote() {
  return (
        <aside className={styles.wrapper}>
            <Text color={colors.gray6}>
                장바구니에 담은 상품은 최대 30일간 보관됩니다.
            </Text>
        </aside>
  );
}

export default CartNote;
